<template>
  <div class="detail-page">
    <div class="detail-page__title">
      <div class="page-nav-wrapper">
        <span class="page-nav__item">
          <router-link to="/index" class="page-nav__item-a"> 首页 </router-link>
          /
        </span>

        <span class="page-nav__item">
          <a class="page-nav__item-a"> 搜索 </a>
          /
        </span>
        <span class="page-nav__item">
          <a class="page-nav__item-a"> 详情 </a>
        </span>
      </div>
    </div>

    <div class="detail-article">
      <div class="title" :title="model.title">
        {{ model.title }}
      </div>
      <div class="subtitle">
        发布时间： {{ model.addtime | dayjs("year-date") }}
        <span style="padding-left: 2em">来源：{{ model.resource }}</span>
      </div>
      <div class="con" v-html="model.content"></div>
    </div>
  </div>
</template>

<script>
import { getOneBySearch } from "@/apis/news";
export default {
  data() {
    return {
      model: {},
    };
  },
  computed: {
    matched() {
      return this.$route.matched;
    },
  },
  watch: {
    $route() {
      this.getOneBySearch();
    },
  },
  created() {
    this.getOneBySearch();
  },
  methods: {
    async getOneBySearch() {
      const { data } = await getOneBySearch({
        id: this.$route.query.id,
        type: this.$route.query.type,
      });
      this.model = data;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
